import { render, staticRenderFns } from "./goodsData.vue?vue&type=template&id=cb645f26&scoped=true&"
import script from "./goodsData.vue?vue&type=script&lang=js&"
export * from "./goodsData.vue?vue&type=script&lang=js&"
import style0 from "./goodsData.vue?vue&type=style&index=0&id=cb645f26&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb645f26",
  null
  
)

export default component.exports